<div class="d-flex flex-column justify-content-center wrapper">
  <div class="offcanvas-body d-flex flex-column">
    <h4 class="text-uppercase">{{ 'Point summary' | translate }}</h4>

    <div class="mt-4 d-flex justify-content-between align-items-center">
      <h6>{{ 'Bookings' | translate }}</h6>
      <div>{{ (accountSummary$ | async)?.salePoints | number }}</div>
    </div>
    <div class="mt-2 d-flex justify-content-between align-items-center">
      <h6>{{ 'Promotion' | translate }}</h6>
      <div>{{ (accountSummary$ | async)?.promoPoints | number }}</div>
    </div>
    <div class="mt-2 d-flex justify-content-between align-items-center">
      <h6>{{ 'Redeemed' | translate }}</h6>
      <div>{{ (accountSummary$ | async)?.redeemedPoints | number }}</div>
    </div>
    <div class="mt-2 d-flex justify-content-between align-items-center">
      <h6>{{ 'Expired' | translate }}</h6>
      <div>{{ (accountSummary$ | async)?.expiredPoints | number }}</div>
    </div>
    <div class="mt-2 d-flex justify-content-between align-items-center">
      <h6>{{ 'Total' | translate }}</h6>
      <div>{{ (accountSummary$ | async)?.availableBalance | number }}</div>
    </div>
  </div>
  <hr />
  <div class="offcanvas-body d-flex flex-column">
    <div class="d-flex justify-content-between align-items-center">
      <h6>
        {{ 'Year Points available to redeem until' | translate }}
        {{ (currentYearAccountSummary$ | async)?.expirationDate | date }}
      </h6>
      <div class="ms-3">{{ (currentYearAccountSummary$ | async)?.availableBalance | number }}</div>
    </div>
  </div>
</div>
